import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'chevron-compact-right',
  'IconChevronCompactRight',
  [['path', { d: 'M11 4l3 8l-3 8', key: 'svg-0' }]],
);
